// extracted by mini-css-extract-plugin
export default {"menuItem":"SelectGame_menuItem__q6LTe","title":"SelectGame_title__i7o3C"};